import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../Auth/Login.vue'
import Home from '../views/Home.vue'
import Register from '../Auth/Register.vue'
import VerifyEmail from '../Auth/VerifyEmail.vue'
import Approve from '../views/approve.vue'
// import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { guestOnly: true }
  },
  {
    name: 'register',
    path: '/register',
    component: Register,
    meta: { guestOnly: true }
  },
  {
    name: 'verify',
    path: '/verify',
    component: VerifyEmail,
    meta: { guestOnly: true }
  },
  {
    name: 'approve',
    path: '/approve',
    component: Approve
  }

]

const router = new VueRouter({
  mode: 'history',
  // base: '/flights/',
  routes
})

router.beforeEach((to, from, next) => {
  // const isLoggedIn = !!store.state.user
  const isLoggedIn = localStorage.getItem('BVtoken')
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ name: 'login' })
  } else if (to.meta.guestOnly && isLoggedIn) {
    next({ name: 'home' })
  } else {
    next()
  }
})
export default router
